import { useContext } from "react";
import { ReportModalContext } from ".";

export const useReportModal = () => useContext(ReportModalContext);
